import { v4 as uuidv4 } from 'uuid';

const controllers = {};

export default function useUploadFile(id = uuidv4()) {
    const uploadFile = async (file, fileName) => {
        controllers[id] = new AbortController();
        
        try {
            // Create FormData to send file to our API
            const formData = new FormData();
            formData.append('file', file);
            formData.append('fileName', fileName);
            
            // Upload via our API endpoint instead of directly to Vercel Blob
            const response = await fetch('/api/blob-upload', {
                method: 'POST',
                body: formData,
                signal: controllers[id].signal,
            });
            
            if (!response.ok) {
                throw new Error(`Upload failed: ${response.statusText}`);
            }
            
            const result = await response.json();
            return result;
        } catch (error) {
            if (error.name === 'AbortError') {
                throw new Error('Upload cancelled');
            }
            throw error;
        }
    };

    const cancelUploadFile = () => { 
        controllers[id]?.abort();
        controllers[id] = null;
    };

    return { uploadFile, cancelUploadFile };
}
